import { useQuery } from "@tanstack/react-query";
import { getValueSection } from "../../api/apiValueSection";

export const useGetValueSection = () => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["value-section"],
        queryFn: getValueSection,
    });

    return {
        valueSection: data?.data || {},
        isLoading,
        error,
        refetch,
    };
};
